<template>
  <div class="contact-items">
    <div>
      <p class="contact-items__title font__roboto">Mail</p>
      <p class="contact-items__mail font__roboto">aozora.hiyamizu@gmail.com</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Contact",
};
</script>
<style lang="scss" scoped>
.contact-items {
  width: 87%;
  margin: 45px auto 0 auto;
}
.contact-items__title {
  display: inline-block;
  line-height: normal;
  font-size: 20px;
  border-bottom: solid 1px #000000;
}
.contact-items__mail {
  margin-top: 10px;
  font-size: 18px;
  letter-spacing: 0.5px;
}
// PC
@media screen and (min-width:1025px) {
  .contact-items {
    width: 60%;
    margin: 100px auto 0 auto;
  }
}

</style>